import React, { useId, useRef, useEffect } from 'react'
import styles from './ThreeDimensionModal.module.sass'
import { EditableDescription, EditableTitle } from '@components/atoms'
import { Close } from '@components/icons'
import { WModal } from '@components/atoms'
import useIsMobile from '@hooks/useIsMobile'
import { clickInRef } from '@utils/safe'

interface Props {
  isOpen: boolean
  onClose: () => void
  title: string
  description: string
  className?: string
}

const ThreeDimensionModal = (props: Props) => {
  const { isOpen, onClose, title, description, className = '' } = props
  const id = useId()
  const isMobile = useIsMobile()
  const dialogRef = useRef<HTMLDialogElement>(null)

  if (!isOpen) return null

  // modal content
  const content = (
    <div className={styles.contentWrapper} onClick={(e) => e.stopPropagation()}>
      <div className={styles.main}>
        <EditableTitle variant="h3" title={title} className={styles.title} />
        <EditableDescription description={description} className={styles.description} />
      </div>
      <button className={styles.closeButton} onClick={onClose}>
        <Close className={styles.closeIcon} />
      </button>
    </div>
  )

  if (isMobile) {
    return (
      <WModal
        id={id}
        open={isOpen}
        onClose={onClose}
        className={styles.dialogBase}
        ariaLabel={title}
      >
        {content}
      </WModal>
    )
  }

  return (
    <dialog
      ref={dialogRef}
      open
      className={`${styles.dialogBase} ${className}`}
      onClick={(e) => {
        if (dialogRef.current && !clickInRef(e as any, dialogRef.current)) {
          onClose()
        }
      }}
    >
      {content}
    </dialog>
  )
}

export default ThreeDimensionModal
